import { Video } from "lucide-react";

/**
 * MissionVideo — 16:9 video frame for the elementary missions.
 *
 * Behavior:
 *   - If `url` is present: render an iframe embed (works for YouTube/Vimeo
 *     embed URLs).
 *   - If `url` is missing and `placeholder` is true: render a clean
 *     "Video coming soon" frame (used on preview stubs only).
 *   - Otherwise: render nothing — keeps blank functional missions clean.
 */
export default function MissionVideo({
  url,
  title,
  placeholder = false,
  testId,
}) {
  if (!url && !placeholder) return null;

  return (
    <div
      className="mb-5 rounded-2xl overflow-hidden ring-1 ring-yellow-200 bg-white shadow-sm"
      data-testid={testId}
    >
      <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
        {url ? (
          <iframe
            className="absolute inset-0 w-full h-full"
            src={url}
            title={title || "Mission video"}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-yellow-50 to-amber-50">
            <div className="w-14 h-14 rounded-2xl bg-yellow-500 text-white flex items-center justify-center shadow-sm mb-3">
              <Video className="w-6 h-6" />
            </div>
            <p className="text-yellow-800 font-bold">Video coming soon</p>
            {title && (
              <p className="text-yellow-700 text-sm mt-1">{title}</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
